import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/**
 * Performance Max on the YouTube watch page (mobile): landscape image in the
 * player, with the companion card (logo, headline, CTA, description) below.
 */
@Component({
    selector: 'app-pmax-youtube-mobile-06',
    imports: [
        CommonModule,
        MobileFrameComponent,
    ],
    templateUrl: './youtube-mobile-06.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/youtube/youtube-mobile-styles.scss',
        './youtube-mobile-06.component.scss',
    ]
})
export class PmaxYoutubeMobile06PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** This placement's creative slot is the landscape format. */
  readonly creativeFormat: CreativeFormat = 'landscape';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** Companion card carousel dots; the first is active. */
  readonly dots = [0, 1, 2, 3];

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
